import PropTypes from "prop-types";
import { useState } from "react";
import {
  FormControlLabel,
  Checkbox,
  Box,
  Typography,
  Paper,
  Divider,
} from "@mui/material";

function MultiCheckboxField({ displayName, fieldRef, options }) {
  const [selected, setSelected] = useState([]);

  const handleChange = (value) => {
    setSelected((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value],
    );
  };

  return (
    <Box>
      <Box mb={1}>
        <Typography variant="subtitle2" fontWeight={400}>
          {displayName}
        </Typography>
      </Box>
      <Box mb={1}>
        <Divider />
      </Box>

      {options?.map((opt) => (
        <Box>
          <FormControlLabel
            key={opt.value}
            control={
              <Checkbox
                checked={selected.includes(opt.value)}
                onChange={() => handleChange(opt.value)}
              />
            }
            label={opt.name}
          />
        </Box>
      ))}

      <input
        type="hidden"
        id={`dff_${fieldRef}`}
        name={fieldRef}
        value={JSON.stringify(selected)}
      />
    </Box>
  );
}

// Typechecking props
MultiCheckboxField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
};

MultiCheckboxField.defaultProps = {
  options: [],
};

export default MultiCheckboxField;
